import { useState } from "react";

const useContactForm = () => {
    const [isSending, setIsSending] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const appApiSendEmailUrl = process.env.REACT_APP_EMAIL_API_URL;

    const sendForm = async (data) => {
        setIsSending(true);
        setErrorMessage("");

        if (!data.name || !data.email || !data.phone || !data.feedback) {
            setIsSending(false);
            setErrorMessage("Todos os campos são obrigatórios.");
            return;
        }

        try {
            const response = await fetch(appApiSendEmailUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ body: data })
            });

            setIsSending(false);

            if (response.status === 200) {
                setIsSuccess(true);
            } else {
                const result = await response.json();
                setErrorMessage(result.message);
            }
        } catch (error) {
            console.log('Erro ao enviar feedback', error);
            setIsSending(false);
            setErrorMessage('Erro ao enviar feedback. Por favor, tente novamente mais tarde.');
        }
    };

    return {
        isSending,
        isSuccess,
        errorMessage,
        sendForm
    };
};

export default useContactForm;